const Privacy = () => (
  <div className="min-h-screen bg-background px-6 py-16">
    <div className="max-w-2xl mx-auto space-y-8">
      <h1 className="font-display text-3xl font-bold">Privacy Policy</h1>
      <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
        <p>Last updated: March 2026</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">What we collect</h2>
        <p>When you join our waitlist, we collect your name (optional), email address, and role. When you use our deal screening tool, we store the inputs you provide and the results generated.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">How we use it</h2>
        <p>Your data is used solely to provide the Brickshare service and communicate product updates. We do not sell, share, or rent your personal information to third parties.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Data storage</h2>
        <p>Your data is stored securely using industry-standard encryption and access controls. Deal data is only accessible to the account that created it.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Contact</h2>
        <p>For questions about this policy, contact us at <a href="mailto:hello@brickshare.ai" className="text-accent hover:underline">hello@brickshare.ai</a>.</p>
      </div>
    </div>
  </div>
);

export default Privacy;
